import { UsageMetricKey } from '../Constants/VOSS/usageMetricKey';
import type { CustomerUsagePeriod } from '../Constants/VOSS/usageTypes';
import { UsageStatus } from '../Constants/VOSS/usageTypes';

export { UsageStatus };

export function getUsageStatus(period: CustomerUsagePeriod | null | undefined, metricKey: UsageMetricKey): UsageStatus {
    if (!period) return UsageStatus.Neutral;
    if (metricKey === UsageMetricKey.CustomerInvoices) return UsageStatus.Neutral;
    const limit = period.includedQuantity;
    if (limit === null || limit <= 0) return UsageStatus.Neutral;
    if (period.currentUsage === null) return UsageStatus.Neutral;

    const ratio = period.currentUsage / limit;
    if (ratio > 1) return UsageStatus.Over;
    if (ratio >= 0.8) return UsageStatus.Warning;
    return UsageStatus.Ok;
}

export function getUsagePercent(period: CustomerUsagePeriod | null | undefined): number {
    if (!period) return 0;
    const limit = period.includedQuantity;
    if (limit === null || limit <= 0) return 0;
    if (period.currentUsage === null) return 0;
    return Math.round((period.currentUsage / limit) * 100);
}

export function getRemaining(period: CustomerUsagePeriod | null | undefined): number | null {
    if (!period) return null;
    const limit = period.includedQuantity;
    if (limit === null) return null;
    if (period.currentUsage === null) return null;
    return Math.max(0, limit - period.currentUsage);
}
